var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lives-wrapbox"},[_c('live-list',{attrs:{"checked-list":_vm.info.webinars}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }